import { useState, useEffect } from 'react';

export function useLocalStorageState<T>(key: string, initialValue: T, useSessionStorage?: boolean): [ T, React.Dispatch<T> ] {
  // Get the stored value from localStorage or use the initial value
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = useSessionStorage ? window.sessionStorage.getItem(key) : window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  // Update localStorage whenever the stored value changes
  useEffect(() => {
    try {
      if (useSessionStorage) {
        window.sessionStorage.setItem(key, JSON.stringify(storedValue));
      } else {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      }
    } catch (error) {
      console.error(error);
    }
  }, [key, storedValue]);

  return [ storedValue, setStoredValue ];
}
